import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './VideoGallery.css'
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

const VideoGallery = () => {
  const [galVideos, setGalVideos] = useState([]);
  const url = process.env.REACT_APP_BASE_URL

  // Fetch gallery images
  const fetchGalVideos = async () => {
    try {
      const response = await axios.get(url + '/api/video/all');
      setGalVideos(response.data.data);
     
     
    } catch (error) {
      console.error('Error fetching gallery images:', error);
   
    }
  };

  // Call fetchGalImages once when component mounts
  useEffect(() => {
    fetchGalVideos();
  }, []);
   
  // Handle image delete logic
  const handleDeleteImage = async (id) => {
    
      try {
        await axios.delete(`${url}/api/video/delete/${id}`);
        // Remove the deleted image from the local state without needing to refetch all images
        setGalVideos(galVideos.filter(image => image._id !== id));
        // console.log("Image deleted successfully");
        toast.success("Image deleted successfully ")
      } catch (error) {
        // console.error('Error deleting image:', error);
       
      }
    
  };

   return (
      <div className="admin-gallery-container">
       <div className='admin-gallary-top'>
       <h1>Admin Gallery Management</h1>
       <Link className='add-button' to="/admin/dashboard/add-video">Add</Link>
       </div>
        <div className="image-grid-container">
          {galVideos.map((item,index) => (
            <div key={item._id} className="image-item">
             <iframe
                         key={index}
                         src={item.videoUrl}
                         title={item.title || "Video"}
                         frameBorder="0"
                         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                         referrerPolicy="strict-origin-when-cross-origin"
                         allowFullScreen
                         style={{ pointerEvents: 'none' }} // Disable iframe interaction if necessary
                       />
               <button onClick={() => handleDeleteImage(item._id)}>Delete</button>
              </div>
                        
          ))}
        </div>
     
      </div>
    );
}

export default VideoGallery